import { uniq } from 'ramda';

interface Peer {
  name: string;
  id: string;
  institutionId: string;
  country: string;
  continent: string;
}

export const getPeerSelectorData = (peers: Peer[]) => {
  const continents = uniq(peers.map((peer) => peer.continent));

  return continents.map((continent) => {
    const countries = uniq(
      peers
        .filter((peer) => peer.continent === continent)
        .map((peer) => peer.country),
    );

    return {
      name: continent,
      children: countries.map((country) => ({
        name: country,
        children: peers
          .filter(
            (peer) => peer.continent === continent && peer.country === country,
          )
          .map((peer) => ({
            name: peer.name,
            id: peer.institutionId,
          })),
      })),
    };
  });
};
